import { render, staticRenderFns } from "./product_registration_step_2.vue?vue&type=template&id=05af0ab0&scoped=true"
import script from "./product_registration_step_2.vue?vue&type=script&lang=js"
export * from "./product_registration_step_2.vue?vue&type=script&lang=js"
import style0 from "./product_registration_step_2.vue?vue&type=style&index=0&id=05af0ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af0ab0",
  null
  
)

export default component.exports